"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/VariableDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _broadcastTemplate = require('shared/services/broadcastTemplate');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _pending = require('web/screens/Broadcast/Wizard/Recipients/pending');
var _noAutofill = require('web/screens/Broadcast/Wizard/Recipients/noAutofill');






















/* What's wrong with a typed variable name, if anything. */
 const variableNameProblem = (name, existing) => {
  if (!_pending.VARIABLE_NAME.test(name)) return 'Use letters, digits or _'
  if (_broadcastTemplate.isBuiltInVariable.call(void 0, name)) return `{{${name}}} comes from the patient record. Insert it from Insert variable.`
  if (existing.includes(name)) return 'Already a column'
  return null
}; exports.variableNameProblem = variableNameProblem

/* Rev 31 v2 frame 6: + Add variable, and Edit variable… from a column's
 * header. The name is slugged as it's typed ("Clinic Location" is
 * {{clinic_location}}). The default is what every recipient without their
 * own value gets. It's optional (Rev 34 S4): a recipient with no value is
 * flagged only once the message uses the variable. */
const VariableDialog = ({ isOpen, editing, existing, isSaving, error, onClose, onSave }) => {
  const id = _react.useId.call(void 0, )
  const [draft, setDraft] = _react.useState.call(void 0, '')
  const [fallback, setFallback] = _react.useState.call(void 0, '')
  // The fields start from the variable once per opening, so a refresh of the
  // page behind it or a refused save keeps what was typed (review R800-67).
  const opening = isOpen ? (editing ? `edit:${editing.name}` : 'new') : null
  const [openedFor, setOpenedFor] = _react.useState(null)
  if (opening !== openedFor) {
    setOpenedFor(opening)
    if (opening) {
      setDraft(_nullishCoalesce(_optionalChain([editing, 'optionalAccess', _ => _.name]), () => ( '')))
      setFallback(_nullishCoalesce(_optionalChain([editing, 'optionalAccess', _2 => _2.fallback]), () => ( '')))
    }
  }

  const isNameLocked = !!editing && (editing.isUsed || editing.isSent)
  const name = isNameLocked && editing ? editing.name : _pending.slugVariable.call(void 0, draft)
  const others = existing.filter(n => n !== _optionalChain([editing, 'optionalAccess', _3 => _3.name]))
  const problem = draft.trim() ? exports.variableNameProblem.call(void 0, name, others) : null
  const fallbackProblem = _broadcastTemplateTokens.INVALID_DEFAULT.test(fallback) ? "A default can't contain { or }" : null
  const canSave = !!draft.trim() && !problem && !fallbackProblem && !isSaving
  const submit = () => { if (canSave) onSave(name, fallback.trim()) }
  const onEnter = (e) => {
    if (e.key !== 'Enter') return
    e.preventDefault()
    submit()
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      title: editing ? 'Edit variable' : 'Add a variable',
      className: "recipients-variable",
      onClose: isSaving ? undefined : onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}

      , _react2.default.createElement('div', { className: "recipients-variable--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
        , _react2.default.createElement('label', { className: "recipients-variable--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
          , _react2.default.createElement('span', { className: "recipients-variable--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}, "Name")
          , _react2.default.createElement('input', {
            // oxlint-disable-next-line jsx-a11y/no-autofocus -- the user just asked for a new variable
            autoFocus: !editing,
            className: "blm-text-input recipients-variable--mono" ,
            'aria-label': "Name",
            placeholder: "clinic_location",
            readOnly: isNameLocked,
            'aria-invalid': !!problem,
            'aria-describedby': `${id}-name`,
            ..._noAutofill.NO_AUTOFILL,
            value: draft,
            onChange: e => setDraft(e.target.value),
            onKeyDown: onEnter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
          )
          , _react2.default.createElement('span', { id: `${id}-name`, className: problem ? 'broadcast-wizard--error' : 'recipients-variable--hint', __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
            ,  _nullishCoalesce(problem, () => ( (_optionalChain([editing, 'optionalAccess', _4 => _4.isSent])
              ? "Messages have gone out, so it can't be renamed."
              : _optionalChain([editing, 'optionalAccess', _5 => _5.isUsed])
              ? "The message uses it, so it can't be renamed."
              : name && _react2.default.createElement(_react2.default.Fragment, null, "Use it in your message as "      , _react2.default.createElement('code', { className: "recipients-variable--token", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}},  `{{${name}}}` ))
            )))
          )
        )
        , _react2.default.createElement('label', { className: "recipients-variable--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
          , _react2.default.createElement('span', { className: "recipients-variable--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}, "Default value "
              , _react2.default.createElement('span', { className: "broadcast-add-dialog--optional", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, "(optional)")
          )
          , _react2.default.createElement('input', {
            // oxlint-disable-next-line jsx-a11y/no-autofocus -- editing a variable is mostly editing its default
            autoFocus: !!editing,
            className: "blm-text-input",
            'aria-label': "Default value" ,
            'aria-invalid': !!fallbackProblem,
            'aria-describedby': `${id}-default`,
            ..._noAutofill.NO_AUTOFILL,
            value: fallback,
            onChange: e => setFallback(e.target.value),
            onKeyDown: onEnter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
          )
          , _react2.default.createElement('span', { id: `${id}-default`, className: fallbackProblem ? 'broadcast-wizard--error' : 'recipients-variable--hint', __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
            ,  _nullishCoalesce(fallbackProblem, () => ( 'Every recipient gets this value unless they have their own (from a CSV).')) 
          )
        )
        ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}},  error ) 
      )
      , _react2.default.createElement('div', { className: "recipients-variable--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
        , _react2.default.createElement(_Form.Button, { isSecondary: true, isDisabled: isSaving, onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}, "Cancel")
        , _react2.default.createElement(_Form.Button, { isDisabled: !canSave, isLoading: isSaving, onClick: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}},  editing ? 'Save' : 'Add variable' )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, VariableDialog)
